var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgStock(props) {
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: `url(#${_id})`,
    stroke: "#707175",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.594 15.516a4.922 4.922 0 109.843 0 4.922 4.922 0 00-9.843 0zM22.547 22.547l-3.55-3.551M12 22.547A10.547 10.547 0 1122.547 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.458 22.238C8.033 20.146 7.078 16.343 7.078 12s.955-8.145 2.38-10.238M1.477 11.297h7.71M3.562 5.672h16.875M2.67 16.922h4.843M14.542 1.762a15.173 15.173 0 012.063 6.015"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgStock;